var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.5L12.4999 6.55325C12.255 6.51822 12.0046 6.50009 11.75 6.50009C11.4953 6.50009 11.2449 6.51822 10.9999 6.55327L11 3.5H3.5V11H6.55318C6.51813 11.245 6.5 11.4954 6.5 11.7501C6.5 12.0047 6.51812 12.2551 6.55315 12.5H3.5V14H2V12.5H0.5V11H2V3.5H0.5V2H2V0.5H3.5V2H11V0.5H12.5V2H14V3.5H12.5ZM8 11.75C8 9.68 9.68 8 11.75 8C13.82 8 15.5 9.68 15.5 11.75C15.5 13.82 13.82 15.5 11.75 15.5C9.68 15.5 8 13.82 8 11.75ZM11.375 11.9L12.9875 13.5125L13.5125 12.98L12.125 11.5925V9.5H11.375V11.9Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiIcon);
export default __webpack_public_path__ + "static/media/ci_icon.a75d49422374cbe342069a15f50841f5.svg";
export { ForwardRef as ReactComponent };